<template>
  <div class="breadcrumbs">
    <ul itemtype="http://schema.org/BreadcrumbList" itemscope="1">
      <template v-if="items && !locid">
        <li
          itemtype="http://schema.org/ListItem"
          itemscope="1"
          itemprop="itemListElement"
          v-for="(crumb, idx) in items"
          :key="idx"
        >
          <a
            v-if="crumb.link != ''"
            itemprop="item"
            :href="crumb.link"
            :title="crumb.name"
            rel="nofollow"
          >
            <span itemprop="name">{{ crumb.name }}</span>
          </a>

          <span v-else itemprop="item">
            <span itemprop="name">{{ crumb.name }}</span>
          </span>

          <meta :content="idx + 1" itemprop="position" />
        </li>
      </template>
      <template v-else>
        <li
          itemtype="http://schema.org/ListItem"
          itemscope="1"
          itemprop="itemListElement"
          v-for="(crumb, idx) in breadcrumbs"
          :key="idx"
        >
          <a
            v-if="crumb.link != ''"
            itemprop="item"
            :href="crumb.link"
            :title="crumb.name"
            rel="nofollow"
          >
            <span itemprop="name">{{ crumb.name }}</span>
          </a>

          <span v-else itemprop="item">
            <span itemprop="name">{{ crumb.name }}</span>
          </span>
          <meta :content="idx + 1" itemprop="position" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import * as GEOSTRUCTURE from "../../../geotree.js";

export default {
  name: "card-breadcrumbs",
  props: {
    items: Array,
    locid: String,
  },
  data: () => ({
    geostruct: GEOSTRUCTURE.geostruktura,
    breadcrumbs: [],
  }),
  methods: {
    breadCrumbs(locid, geoStruct) {
      let crumbsArr = [];
      let offersLinkPrefix = "/oferta/szukaj.xml?locid=";

      for (let i = 0; i < geoStruct.Country.Region.length; i++) {
        let elem = geoStruct.Country.Region[i];

        if (elem.locID == locid) {
          crumbsArr.push({
            name: elem.name,
            link: offersLinkPrefix + elem.locID,
          });

          this.breadcrumbs = crumbsArr;
          return this.breadcrumbs;
        }

        if (elem.Miniregion) {
          for (let j = 0; j < elem.Miniregion.length; j++) {
            let elem2 = elem.Miniregion[j];

            if (elem2.locID == locid) {
              crumbsArr.push(
                { name: elem.name, link: offersLinkPrefix + elem.locID },
                { name: elem2.name, link: offersLinkPrefix + elem2.locID }
              );
            }

            if (elem2.Areatown) {
              for (let k = 0; k < elem2.Areatown.length; k++) {
                let elem3 = elem2.Areatown[k];

                if (elem3.locID == locid) {
                  crumbsArr.push(
                    { name: elem.name, link: offersLinkPrefix + elem.locID },
                    {
                      name: elem2.name,
                      link: offersLinkPrefix + elem2.locID,
                    },
                    { name: elem3.name, link: offersLinkPrefix + elem3.locID }
                  );
                }

                if (elem3.Place) {
                  for (let l = 0; l < elem3.Place.length; l++) {
                    let elem4 = elem3.Place[l];

                    if (elem4.locID == locid) {
                      crumbsArr.push(
                        {
                          name: elem.name,
                          link: offersLinkPrefix + elem.locID,
                        },
                        {
                          name: elem2.name,
                          link: offersLinkPrefix + elem2.locID,
                        },
                        {
                          name: elem3.name,
                          link: offersLinkPrefix + elem3.locID,
                        },
                        {
                          name: elem4.name,
                          link: offersLinkPrefix + elem4.locID,
                        }
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.breadcrumbs = crumbsArr;
    },
  },
  mounted() {
    let geoStruct = this.geostruct.geotree;
    let locid = this.locid;
    this.breadCrumbs(locid, geoStruct);
  },
  watch: {
    locid: function () {
      let geoStruct = this.geostruct.geotree;
      let locid = this.locid;
      this.breadCrumbs(locid, geoStruct);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/T1Breadcrumbs/T1BreadcrumbsStyles";
</style>
